import { mergeProps } from '@base-ui/react/merge-props';
import { NavigationMenu } from '@base-ui/react/navigation-menu';
import { type RefObject } from 'react';

type TriggerRender = Extract<NavigationMenu.Trigger.Props['render'], (...args: never[]) => unknown>;
export type TriggerRenderProps = Parameters<TriggerRender>[0];
export type TriggerRenderState = Parameters<TriggerRender>[1];

type SplitTriggerPropsParams = {
    buttonRef: RefObject<HTMLButtonElement | null>;
    isOpen: boolean;
    label: string;
    onKeyboardClose: () => void;
    onKeyboardOpen: () => void;
    onPointerOpen: () => void;
    props: TriggerRenderProps;
};

export function splitTriggerProps({
    buttonRef,
    isOpen,
    label,
    onKeyboardClose,
    onKeyboardOpen,
    onPointerOpen,
    props,
}: SplitTriggerPropsParams) {
    const {
        ref,
        role: _role,
        tabIndex,
        onClick,
        onKeyDown,
        onKeyUp,
        onMouseDown,
        onPointerDown,
        onMouseEnter,
        onPointerEnter,
        'aria-controls': ariaControls,
        'aria-expanded': ariaExpanded,
        ...groupProps
    } = props;

    return {
        groupProps: mergeProps<'div'>(groupProps, {
            ref,
            role: 'group',
            tabIndex: -1,
            onFocus(event) {
                if (event.target === event.currentTarget) {
                    buttonRef.current?.focus();
                }
            },
        }),
        linkProps: mergeProps<'a'>(
            {
                onMouseEnter,
                onPointerEnter,
            },
            {
                onPointerEnter: onPointerOpen,
            }
        ),
        buttonProps: mergeProps<'button'>(
            {
                ref: buttonRef,
                tabIndex,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-label': `Toggle ${label} submenu`,
                onClick,
                onKeyDown,
                onKeyUp,
                onMouseDown,
                onPointerDown,
            },
            {
                onClick(event) {
                    if (isOpen) {
                        event.preventBaseUIHandler();
                        onKeyboardClose();
                    }
                },
                onKeyDown(event) {
                    if (event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowDown') {
                        onKeyboardOpen();
                    }
                },
            }
        ),
    };
}
